'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../../breakdown-chart/templates/demand-posting-chart-tooltip.html'));
var DemandPostingOperationController = function DemandPostingOperationController($rootScope, $scope, $filter) {
  var rmNumberFormat = $filter('rmNumberFormat');
  function getOperationParameters(operationData) {
    var source = operationData.sourceProductGroup.selectedItem;
    var target = operationData.targetProductGroup.selectedItem;
    return {
      source: source && source.id ? source.id : source,
      target: target && target.id ? target.id : target,
      adjustmentData: {
        value: operationData.adjAmount.percentageValue,
        type: 'P',
        mode: operationData.shiftSwap.selectedItem.id
      }
    };
  }
  $scope.deleteBtnEnabled = $scope.operationIdx > 0;
  $scope.openBreakdownModal = function () {
    $rootScope.$broadcast('demand-posting:open-breakdown-modal', getOperationParameters($scope.operation));
  };
  $scope.adjAmountBlurHandler = function () {
    if (!$scope.operation.adjAmount.percentageValue) {
      $scope.operation.adjAmount.percentageValue = 0;
    }
  };
  $scope.adjAmountFocusHandler = function () {
    if ($scope.operation.adjAmount.percentageValue === 0) {
      $scope.operation.adjAmount.percentageValue = '';
    }
  };
  $scope.enableChartBtn = function () {
    $scope.chartBtnEnabled = !!($scope.operation.sourceProductGroup.selectedItem && $scope.operation.sourceProductGroup.selectedItem.id && $scope.operation.targetProductGroup.selectedItem && $scope.operation.targetProductGroup.selectedItem.id);
  };
  $scope.handleShiftSwapWatcher = function (newValue) {
    if (newValue && newValue.id === 'SWAP') {
      $scope.operation.adjAmount.enabled = false;
      $scope.operation.adjAmount.percentageValue = 1;
    } else if ($scope.operation.adjAmount.enabled === false) {
      $scope.operation.adjAmount.enabled = true;
      $scope.operation.adjAmount.percentageValue = 0;
    }
  };
  $scope.getTooltipContent = function (mode) {
    var classGrpProperty = mode === 'source' ? 'sourceProductGroup' : 'targetProductGroup';
    var classGroup = $scope.operation[classGrpProperty] && $scope.operation[classGrpProperty].selectedItem && $scope.operation[classGrpProperty].selectedItem.label;
    if (classGroup) {
      var demandProperty = mode === 'source' ? 'sourceDemand' : 'targetDemand';
      var values = $scope.operation && $scope.operation[demandProperty];
      var change = (values.newValue - values.oldValue) / values.oldValue * 100;
      return tooltipTemplate({
        mode: mode,
        model: rmNumberFormat(values.oldValue, 'NUMBER'),
        effective: rmNumberFormat(values.newValue, 'NUMBER'),
        change: change !== 0 ? rmNumberFormat(Math.abs(change), 'PERCENTAGE') : 'N/A',
        changeCss: values.oldValue && change !== 0 && !_.isNaN(change) ? change : '',
        classGroup: classGroup,
        date: ''
      });
    }
    return '';
  };
  $scope.handleSettingTooltip = function () {
    $scope.operation.sourceTooltip = $scope.getTooltipContent('source');
    $scope.operation.targetTooltip = $scope.getTooltipContent('target');
  };
  $scope.$watch('operation.shiftSwap.selectedItem', function (newValue) {
    $scope.handleShiftSwapWatcher(newValue);
  });
  $scope.$watchGroup(['operation.adjAmount.percentageValue', 'operation.shiftSwap.selectedItem', 'operation.sourceProductGroup.selectedItem', 'operation.targetProductGroup.selectedItem'], function () {
    $scope.onProductGroupChange();
    $scope.enableChartBtn();
    $scope.onAdjAmountChange();
    $scope.handleSettingTooltip();
  });
};
DemandPostingOperationController.$inject = ['$rootScope', '$scope', '$filter'];
module.exports = DemandPostingOperationController;